<template>
  <v-app>
    <pba-app-bar />
    <pba-view class="pa-0" />
    <pba-footer />
  </v-app>
</template>

<script>
  export default {
    name: 'PbaLayout',

    components: {
      PbaAppBar: () => import('@/layouts/LSBD/AppBar'),
      PbaFooter: () => import('@/layouts/LSBD/Footer'),
      PbaView: () => import('@/layouts/LSBD/View'),
    },
  }
</script>

<style lang="scss">
  @import '@/styles/LSBD.scss';
</style>
